import styled, { keyframes } from 'styled-components'
import Icon from '@/modern/components/Icon'

export const Wrapper = styled.div`
  padding: 52px 24px 32px 24px;
  display: flex;
  flex-direction: column;
  width: 560px;
  height: 502px;
  text-align: center;
  margin-top: 10px;
`

export const WrapperError = styled(Wrapper)`
  justify-content: flex-end;
  .server-error {
    background-color: #2E2D37;
  }
`

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 22px;
  background: none;
  border: 0;
  outline: 0;
  cursor: pointer;
`

export const CloseIcon = styled(Icon)``

export const Heading = styled.div`
  color: #2e2d37;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 26px;
`

export const HeadingSuccess = styled(Heading)`
  && {
    color: #27ae60;
    font-size: 20px;
  }
`

export const HeadingEmail = styled(Heading)`
  && {
    color: #2e2d37;
    font-size: 16px;
    font-weight: 700;
    margin: 16px auto;
    width: 412px; 
    word-wrap: break-word;
    white-space: normal;
  }
`

export const Text = styled.div`
  margin-top: 24px;
  margin-bottom: 8px;
  color: #2e2d37;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`
export const Info = styled(Text)`
  && {
    font-size: 10px;
    color: #696977;
    line-height: 12px;
    margin-top: 16px;
    margin-bottom: 0;
  }
`

export const InfoSuccess = styled(Text)``

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 320px;
  height: 56px;
  margin: 16px auto;

  button,
  a {
    padding: 10px 16px;
    text-transform: none;
    font-size: 16px;
    line-height: 24px;
    font-weight: 700;
    width: 100%;
    letter-spacing: unset;
    border-radius: 8px;
    & + button,
    & + a {
      background-color: white;
      color: #f3123c;
    }
  }
`

export const ButtonsContainerError = styled(ButtonsContainer)`
  && {
    margin: 80px auto 0;
  }
`

export const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 16px;
  margin-bottom: 24px;
`

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

export const SpinnerContainer = styled.div`
  background: #fff;
  height: 485px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const RotatingSvg = styled.svg`
  animation: ${rotate} 1s linear infinite;
  width: 68px;
  height: 69px;
`
